export interface IBreadcrumb {
  value: string;
  notTitleCase?: boolean
}
